import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * An accordion allows users to toggle the display of sections of content.
 */
const Accordion = (props) => {
  const { children, className, name, ...otherProps } = props;
  const classNames = classnames('accordion-group', className);
  // eslint-disable-next-line
  const childrenWithProps = React.Children.map(children, (child) => React.cloneElement(child, { name }));
  return (
    <div className={classNames} {...otherProps}>
      {childrenWithProps}
    </div>
  );
};

Accordion.propTypes = {
  /** Additional classes. */
  className: PropTypes.string,
  /** Accordion sections */
  children: PropTypes.any.isRequired,
  /** Group name */
  name: PropTypes.string.isRequired,
};

Accordion.defaultProps = {
  className: '',
};

Accordion.Item = ({ title, name, id, children, className }) => (
  <div className={className}>
    <div className="accordion">
      <input id={id} type="checkbox" name={name} hidden />
      <label className="accordion-header c-hand" htmlFor={id}>
        <i className="icon icon-angle-right mr-1" />{title}
      </label>
      <div className="accordion-body">
        {children}
      </div>
    </div>
  </div>
);

Accordion.Item.propTypes = {
  /** Additional classes. */
  className: PropTypes.string,
  /** Section title */
  title: PropTypes.string.isRequired,
  /** Section content */
  children: PropTypes.any.isRequired,
  /** Section id */
  id: PropTypes.string.isRequired,
  /** Group name */
  name: PropTypes.string,
};

Accordion.Item.defaultProps = {
  className: '',
  name: '',
};

export { Accordion };
